import React from 'react';
const facts = [{
  value: '159',
  label: 'Split-and-Prove cards'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '40',
  label: 'Field worksheets'
}, {
  value: '4',
  label: 'Countries’ code columns'
}];

// Colores de tomo del producto
const accents = ['before:bg-ember', 'before:bg-vol-2', 'before:bg-vol-4', 'before:bg-vol-5'];
export function SocialProofBar() {
  return <section className="w-full bg-forest-deep" data-id="element-367" data-mp="32jcyol6wfaff">
      <div className="mx-auto max-w-6xl px-5 pb-12 sm:pb-16" data-id="element-368" data-mp="32h0iodkpba50">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-forest-line bg-forest-line sm:grid-cols-4" data-id="element-369" data-mp="2xl34act00duv">
          {facts.map((fact, i) => <div key={fact.label} className={`relative bg-forest-deep px-4 py-5 text-center before:absolute before:inset-x-0 before:top-0 before:h-1 before:content-[''] ${accents[i]}`} data-id="element-370" data-mp="2ojv57sinr8zq" data-mpi={i}>
              <div className="font-display text-4xl leading-none text-ember sm:text-5xl" data-id="element-371" data-mp="1d359j3bv1zkd">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-paper/65" data-id="element-372" data-mp="18m89fix2xtpp">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}